var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner flex"},[_c('div',{staticClass:"leftBox flexColumn"},[_c('box-border',{attrs:{"title":"累计运输货量统计","height":"30%","padding":"0.2rem 0.2rem 0.1rem"}},[_c('echart-module',{ref:"totalStatistics",attrs:{"option":_vm.totalStatistics}})],1),_c('box-border',{attrs:{"title":"运输货量统计","height":"30%","padding":"0.2rem 0.2rem 0.1rem"}},[_c('echart-module',{ref:"volumeStatistics",attrs:{"option":_vm.volumeStatistics}})],1),_c('box-border',{attrs:{"title":"运输进度","height":"15%","margin":"0.1rem 0 0 0"}},[_c('echart-module',{ref:"transportProgress",attrs:{"option":_vm.transportProgress}})],1),_c('div',{staticClass:"flexColumn",staticStyle:{"height":"15%","width":"100%"}},[_c('div',{staticClass:"lineBorder"}),_c('div',{style:({
                height: '95%',
                background: '#0b1547',
                padding: '0 0.2rem'
            })},[_c('scroll-text',{ref:"scrollText",style:({
                        background: '#0b1547'
                    }),attrs:{"loadData":_vm.logisticsDatas,"showName":"v1","firstChild":"lastChild","liStyle":{
                        'font-size': '.14rem',
                        'font-family': 'Microsoft YaHei',
                        'font-weight': 400,
                        'color': '#FFFFFF',
                        'line-height': '.22rem',
                        'white-space': 'normal'
                    }},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.getSpan(data['v1']))},on:{"click":_vm.goToLink}})]}}])})],1),_c('div',{staticClass:"lineBorder"})])],1),_c('div',{ref:"worldMap",staticClass:"world"}),_c('div',{staticClass:"rightNode flexColumnAround"},[_c('div',{staticClass:"flexColumn",staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"lineBorder"}),_c('div',{style:({
                height: '95%',
                background: '#0b1547',
                padding: '0 0.2rem'
            })},[_c('top-tab',{staticClass:"scrollStyle",attrs:{"topBarDatas":_vm.topBarDatas,"getStyle":(item) => {
                        return {
                            'background': item.v5,
                        }
                    },"getIconStyle":(item) => {
                        return {
                            'backgroundImage': `url(${require(`@/assets/Logistics/${item.v6}.png`)})`
                        }
                    },"nameStyle":{
                        color: '#fff'
                    },"divStyle":{
                        'height': 'auto',
                        'margin-bottom': '0',
                        'margin-right': '0',
                        'box-sizing': 'border-box'
                    },"boxStyle":{
                        'contain': 'layout',
                        'height': '100%',
                        'display': 'grid',
                        'overflow-x': 'hidden',
                        'overflow-y': 'auto',
                        'grid-template-columns': 'repeat(2, 1fr)',
                        'grid-row-gap': '0.1rem',
                        'grid-column-gap': '0.1rem'
                    }}})],1),_c('div',{staticClass:"lineBorder"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }